
export interface IHeroLocationData {
    code: string;
    name: string;
    native: string;
    currency: string;
    timezone: string[];
    flag: string;
    languages: string[];
};

export const locationData : IHeroLocationData[] = [{
    name: 'Germany',
    native: 'Deutschland',
    code: 'DE',
    currency: 'EUR',
    timezone: ['Europe/Berlin'],
    flag: '🇩🇪',
    languages: ['de'],
}, {
    name: 'United Kingdom',
    native: 'United Kingdom',
    code: 'GB',
    currency: 'GBP',
    timezone: ['Europe/London'],
    flag: '🇬🇧',
    languages: ['en'],
}, {
    name: 'United States',
    native: 'United States',
    code: 'US',
    currency: 'USD',
    timezone: ['America/New_York', 'America/Los_Angeles', 'America/Chicago'],
    flag: '🇺🇸',
    languages: ['en'],
}, {
    name: 'France',
    native: 'France',
    code: 'FR',
    currency: 'EUR',
    timezone: ['Europe/Paris'],
    flag: '🇫🇷',
    languages: ['fr'],
}, {
    name: 'Italy',
    native: 'Italia',
    code: 'IT',
    currency: 'EUR',
    timezone: ['Europe/Rome'],
    flag: '🇮🇹',
    languages: ['it'],
}, {
    name: 'Spain',
    native: 'España',
    code: 'ES',
    currency: 'EUR',
    timezone: ['Europe/Madrid'],
    flag: '🇪🇸',
    languages: ['es'],
}, {
    name: 'Portugal',
    native: 'Portugal',
    code: 'PT',
    currency: 'EUR',
    timezone: ['Europe/Lisbon'],
    flag: '🇵🇹',
    languages: ['pt'],
}, {
    name: 'Netherlands',
    native: 'Nederland',
    code: 'NL',
    currency: 'EUR',
    timezone: ['Europe/Amsterdam'],
    flag: '🇳🇱',
    languages: ['nl'],
}, {
    name: 'Poland',
    native: 'Polska',
    code: 'PL',
    currency: 'PLN',
    timezone: ['Europe/Warsaw'],
    flag: '🇵🇱',
    languages: ['pl'],
}, {
    name: 'Belgium',
    native: 'België',
    code: 'BE',
    currency: 'EUR',
    timezone: ['Europe/Brussels'],
    flag: '🇧🇪',
    languages: ['fr', 'nl', 'de'],
}];